<template>
    <el-form
        ref="verifyForm"
        :rules="verifyFormRules"
        :model="verifyForm"
        class="verify_form"
        :class="{ white_form: theme == 'white' }"
        @submit.native.prevent
    >
        <el-form-item v-if="params.phoneAuth" prop="phoneCode">
            <div class="label_text">
                {{ $t('message.user.phoneCode') }}
            </div>
            <el-input
                ref="phoneCode"
                v-model="verifyForm.phoneCode"
                placeholder=""
                name="phoneCode"
                type="text"
                maxlength="6"
            >
                <el-button
                    slot="append"
                    class="get_code"
                    :loading="phoneLoading"
                    :disabled="
                        verifyForm.phoneCodeText !== $t('message.user.getCode')
                    "
                    @click="getCode(1)"
                >
                    {{ verifyForm.phoneCodeText }}
                    <i v-if="verifyForm.showPhoneIcon" class="code_icon" />
                </el-button>
            </el-input>
            <div class="code_text">
                {{ $t('message.safeCenter.enterCode')
                }}{{ `${params.phonePass}`
                }}{{ $t('message.safeCenter.codeDigits') }}
            </div>
        </el-form-item>
        <el-form-item v-if="params.emailAuth" prop="emailCode">
            <div class="label_text">
                {{ $t('message.user.emailCode') }}
            </div>
            <el-input
                ref="emailCode"
                v-model="verifyForm.emailCode"
                placeholder=""
                name="emailCode"
                type="text"
                maxlength="6"
            >
                <el-button
                    slot="append"
                    class="get_code"
                    :loading="emailLoading"
                    :disabled="
                        verifyForm.emailCodeText !== $t('message.user.getCode')
                    "
                    @click="getCode(2)"
                >
                    {{ verifyForm.emailCodeText }}
                    <i v-if="verifyForm.showEmailIcon" class="code_icon" />
                </el-button>
            </el-input>
            <div class="code_text">
                {{ $t('message.safeCenter.enterCode')
                }}{{ `${params.emailPass}`
                }}{{ $t('message.safeCenter.codeDigits') }}
            </div>
        </el-form-item>
        <el-form-item v-if="params.googleAuth" prop="googleCode">
            <div class="label_text">
                {{ $t('message.user.googleCode') }}
            </div>
            <el-input
                ref="googleCode"
                v-model="verifyForm.googleCode"
                placeholder=""
                name="googleCode"
                type="text"
                maxlength="6"
            />
            <div class="code_text">
                {{ $t('message.safeCenter.googleAuthCode') }}
            </div>
        </el-form-item>
        <!-- <div class="not_use">安全验证不可用？</div> -->
    </el-form>
</template>
<script>
import { validateCode } from '@/utils';
import { mapState } from 'vuex';

export default {
    props: {
        businessType: {
            type: [String, Number],
            default: null
        },
        theme: {
            type: String,
            default: 'black'
        }
    },
    data() {
        return {
            verifyForm: {
                phoneCode: null,
                emailCode: null,
                googleCode: null,
                phoneCodeText: this.$t('message.user.getCode'),
                showPhoneIcon: false,
                emailCodeText: this.$t('message.user.getCode'),
                showEmailIcon: false,
                phoneTimer: null,
                phoneTime: 60,
                emailTimer: null,
                emailTime: 60
            },
            verifyFormRules: {
                phoneCode: [
                    {
                        required: true,
                        trigger: 'change',
                        validator: validateCode
                    }
                ],
                emailCode: [
                    {
                        required: true,
                        trigger: 'change',
                        validator: validateCode
                    }
                ],
                googleCode: [
                    {
                        required: true,
                        trigger: 'change',
                        validator: validateCode
                    }
                ]
            },
            phoneLoading: false,
            emailLoading: false
        };
    },
    computed: {
        ...mapState({
            user_info: state => state.user.user_info
        }),
        params() {
            return {
                phone_area_code: this.user_info.area_phone_code,
                phoneAuth: this.user_info.is_phone_auth,
                phone: this.user_info.phone_number,
                phonePass: this.user_info.phone_pass,
                emailAuth: this.user_info.is_email_auth,
                email: this.user_info.email_addr,
                emailPass: this.user_info.email_pass,
                googleAuth: this.user_info.is_google_auth
            };
        }
    },
    watch: {
        verifyForm: {
            handler(newVal) {
                const params = {
                    phoneCode: newVal.phoneCode,
                    emailCode: newVal.emailCode,
                    googleCode: newVal.googleCode
                };
                this.$emit('updateForm', params);
            },
            deep: true
        }
    },
    destroyed() {
        this.clearCountdown();
    },
    methods: {
        // 获取验证码
        getCode(type) {
            const param = {};
            param.business_type = this.businessType || 202;
            param.send_type = type;
            if (type === 1) {
                param.phone_area_code = this.params.phone_area_code;
                param.phone = this.params.phone;
                this.phoneLoading = true;
                this.verifyForm.phoneCodeText = '';
            } else {
                param.email = this.params.email;
                this.emailLoading = true;
                this.verifyForm.emailCodeText = '';
            }
            this.$store
                .dispatch('user/sendCode', param)
                .then(() => {
                    if (type === 1) {
                        this.phoneLoading = false;
                        this.verifyForm.showPhoneIcon = true;
                        this.verifyForm.phoneCodeText = this.$t(
                            'message.user.sended'
                        );
                        this.verifyForm.phoneTimer = setInterval(() => {
                            this.verifyForm.phoneTime--;
                            this.verifyForm.phoneCodeText = `${this.verifyForm.phoneTime}s${this.$t('message.common.retrieve')}`;
                            this.verifyForm.showPhoneIcon = false;
                            if (this.verifyForm.phoneTime <= 0) {
                                clearInterval(this.verifyForm.phoneTimer);
                                this.verifyForm.phoneCodeText = this.$t(
                                    'message.user.getCode'
                                );
                                this.verifyForm.phoneTime = 60;
                            }
                        }, 1000);
                    } else {
                        this.emailLoading = false;
                        this.verifyForm.showEmailIcon = true;
                        this.verifyForm.emailCodeText = this.$t(
                            'message.user.sended'
                        );
                        this.verifyForm.emailTimer = setInterval(() => {
                            this.verifyForm.emailTime--;
                            this.verifyForm.emailCodeText = `${this.verifyForm.emailTime}s${this.$t('message.common.retrieve')}`;
                            this.verifyForm.showEmailIcon = false;
                            if (this.verifyForm.emailTime <= 0) {
                                clearInterval(this.verifyForm.emailTimer);
                                this.verifyForm.emailCodeText = this.$t(
                                    'message.user.getCode'
                                );
                                this.verifyForm.emailTime = 60;
                            }
                        }, 1000);
                    }
                })
                .catch(() => {
                    this.phoneLoading = false;
                    this.emailLoading = false;
                    this.verifyForm.phoneCodeText = this.$t(
                        'message.user.getCode'
                    );
                    this.verifyForm.emailCodeText = this.$t(
                        'message.user.getCode'
                    );
                });
        },
        clearCountdown() {
            if (this.verifyForm.phoneTimer) {
                clearInterval(this.verifyForm.phoneTimer);
                this.verifyForm.phoneCodeText = this.$t('message.user.getCode');
                this.verifyForm.phoneTime = 60;
            }
            if (this.verifyForm.emailTimer) {
                clearInterval(this.verifyForm.emailTimer);
                this.verifyForm.emailCodeText = this.$t('message.user.getCode');
                this.verifyForm.emailTime = 60;
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.verify_form {
    width: 100%;
    .label_text {
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
        line-height: 20px;
        margin-bottom: 4px;
    }
    .code_text {
        font-size: 12px;
        font-weight: 500;
        color: #636b75;
        margin-top: 4px;
        line-height: 17px;
    }
    .el-form-item {
        margin-bottom: 20px;
        &:last-child {
            margin-bottom: 0;
        }
    }
    .el-input {
        width: 100%;
        height: 41px;
        border-radius: 4px;
        border: 1px solid #474d57;
        ::v-deep {
            .el-input__inner {
                border: none;
                height: 39px;
            }
            .el-input-group__append {
                border: none;
            }
        }
    }
    .get_code {
        border: none;
        font-size: 14px;
        font-weight: 500;
        color: $basicColor;
        background-color: transparent;
        padding: 0 12px;
        height: 39px;
        .code_icon {
            display: inline-block;
            width: 13px;
            height: 13px;
            margin-left: 6px;
            background: url('@/assets/user/tips_icon.png') 100% 100% no-repeat;
            background-size: cover;
        }
    }
    .not_use {
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 500;
        color: $basicColor;
        margin-bottom: 12px;
    }
    &.white_form {
        .el-input {
            border-color: #ededed;
        }
        .label_text {
            color: #636b75;
        }
        .code_text {
            color: #90959c;
        }
    }
}
</style>
